import { RESCUE_ATTR } from '../global/assetRescueState';

const PACKS_PATH_MARKER = '/packs/';

const withTrailingSlash = (value) => (value.endsWith('/') ? value : `${value}/`);

const assetRootFromUrl = (assetUrl) => {
  if (!assetUrl || !assetUrl.includes(PACKS_PATH_MARKER)) {
    return null;
  }

  try {
    const resolvedUrl = new URL(assetUrl, window.location.origin);
    const packsPathIndex = resolvedUrl.pathname.indexOf(PACKS_PATH_MARKER);

    if (packsPathIndex === -1) {
      return null;
    }

    return withTrailingSlash(
      `${resolvedUrl.origin}${resolvedUrl.pathname.slice(0, packsPathIndex)}`,
    );
  } catch {
    return null;
  }
};

const elementAssetUrl = (element) => element.getAttribute('src') || element.getAttribute('href');

export const inferAssetRootFromLoadedPacks = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return null;
  }

  // The executing script knows which origin actually delivered the bundle.
  // It must outrank DOM order: after an asset rescue (assetRescueWatchdog),
  // the dead CDN tags are still first in the DOM, and deriving the root from
  // them would point every lazy chunk back at the unreachable host.
  try {
    const currentScriptRoot = document.currentScript
      ? assetRootFromUrl(document.currentScript.getAttribute('src'))
      : null;
    if (currentScriptRoot) {
      return currentScriptRoot;
    }
  } catch {
    // Fall through to DOM-based inference.
  }

  const assetElements = Array.from(document.querySelectorAll('script[src], link[href]'));

  // Same reasoning for contexts where currentScript is unavailable: the
  // rescue-injected tags are the ones that actually loaded, so they outrank
  // the original tags.
  const rescuedRoot = assetElements
    .filter((element) => element.getAttribute(RESCUE_ATTR))
    .map((element) => assetRootFromUrl(elementAssetUrl(element)))
    .find(Boolean);
  if (rescuedRoot) {
    return rescuedRoot;
  }

  return assetElements
    .map((element) => assetRootFromUrl(elementAssetUrl(element)))
    .find(Boolean) || null;
};

export const inferRspackPublicPathFromLoadedPacks = () => {
  const assetRoot = inferAssetRootFromLoadedPacks();

  return assetRoot ? `${assetRoot}${PACKS_PATH_MARKER.slice(1)}` : null;
};
